import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import '../Styles/Lightbox.css';

export function Lightbox({ images, currentIndex, onClose, onNext, onPrev }) {
	const [direction, setDirection] = useState('next');
	const [isLoading, setIsLoading] = useState(true);

	const currentItem = images[currentIndex];
	const isVideo = typeof currentItem === 'string' && 
					(currentItem.includes('youtube.com') || currentItem.includes('youtu.be'));

	useEffect(() => {
		const handleEsc = (e) => {
			if (e.key === 'Escape') onClose();
		};

		document.body.style.overflow = 'hidden';
		window.addEventListener('keydown', handleEsc);

		return () => {
			document.body.style.overflow = 'unset';
			window.removeEventListener('keydown', handleEsc);
		};
	}, [onClose]);

	useEffect(() => {
		setIsLoading(true);
	}, [currentIndex]);

	const lightboxContent = (
		<div className="lightbox-modal" onClick={onClose}>
			<span className="close-lightbox" onClick={onClose}>&times;</span>
			
			<div className="lightbox-content-wrapper">
				<div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
					{isLoading && <div className="lightbox-loader"></div>}

					{isVideo ? (
						<iframe
							key={currentIndex}
							className={`lightbox-video-style slide-anim-${direction} ${isLoading ? 'hidden' : 'visible'}`}
							src={currentItem}
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
							onLoad={() => setIsLoading(false)}
						></iframe>
					) : (
						<img 
							key={currentIndex} 
							src={currentItem} 
							alt="Enlarged" 
							className={`lightbox-img-style slide-anim-${direction} ${isLoading ? 'hidden' : 'visible'}`}
							onLoad={() => setIsLoading(false)}
						/>
					)}
				</div>

				{images.length > 1 && (
					<div className="lightbox-nav" onClick={(e) => e.stopPropagation()}>
						<button className="nav-btn" onClick={() => { setDirection('prev'); onPrev(); }}>←</button>
						<span className="counter-text">{currentIndex + 1} / {images.length}</span>
						<button className="nav-btn" onClick={() => { setDirection('next'); onNext(); }}>→</button>
					</div>
				)}
			</div>
		</div>
	);
	return createPortal(lightboxContent, document.body);
}